import confetti from "canvas-confetti";

window.addEventListener("contrast-party", () => {
  const contrastToggle = document.querySelector(".js-contrast-button");
  const contrastCheckbox = document.querySelector(".js-contrast-checkbox");
  const logoImages = document.querySelectorAll(".js-logo");

  const duration = 5 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = {
    startVelocity: 30,
    spread: 360,
    ticks: 60,
    zIndex: 1200,
    shapes: [
      "circle",
      confetti.shapeFromPath({
        path: "M0.665555 9.41054C0.187262 9.68669 0.0193159 10.302 0.343704 10.749C0.88578 11.4959 1.53381 12.1622 2.26876 12.7262C3.26873 13.4935 4.41004 14.0563 5.62752 14.3825C6.84501 14.7087 8.11482 14.792 9.36447 14.6275C10.6141 14.4629 11.8191 14.0539 12.9107 13.4237C14.0023 12.7935 14.959 11.9544 15.7263 10.9544C16.4936 9.95447 17.0565 8.81316 17.3827 7.59568C17.7089 6.37819 17.7921 5.10838 17.6276 3.85873C17.5067 2.94026 17.2537 2.04591 16.8779 1.20299C16.653 0.698574 16.0361 0.536358 15.5578 0.8125L12.436 2.61487C11.9577 2.89102 11.8079 3.50235 11.9569 4.03416C12.0079 4.2162 12.046 4.40203 12.0708 4.59029C12.1393 5.11021 12.1046 5.63853 11.9689 6.14506C11.8332 6.6516 11.599 7.12645 11.2798 7.54249C10.9605 7.95853 10.5625 8.30762 10.1083 8.56982C9.65418 8.83203 9.15283 9.00221 8.63291 9.07066C8.11299 9.13911 7.58468 9.10448 7.07814 8.96876C6.5716 8.83303 6.09675 8.59886 5.68071 8.27962C5.53006 8.16402 5.38819 8.03809 5.25604 7.9029C4.86999 7.50796 4.26565 7.33203 3.78735 7.60817L0.665555 9.41054Z",
      }),
      confetti.shapeFromPath({
        path: "M0 7.64V1C0 0.447715 0.447715 0 1 0H6C6.55228 0 7 0.447714 7 0.999999V7.64C7 8.19229 6.55228 8.64 6 8.64H1C0.447715 8.64 0 8.19229 0 7.64Z",
      }),
      confetti.shapeFromPath({
        path: "M0 17.2V1C0 0.447715 0.447715 0 1 0H6C6.55228 0 7 0.447714 7 0.999999V17.2C7 17.7523 6.55228 18.2 6 18.2H1C0.447715 18.2 0 17.7523 0 17.2Z",
      }),
    ],
    colors: ["#EB09D4", "#EB6209", "#DCE9C4", "#09B5EB"],
    scalar: 1.5,
  };

  const interval = setInterval(function () {
    let timeLeft = animationEnd - Date.now();
    contrastToggle.style.pointerEvents = "none";

    if (timeLeft <= 0) {
      contrastToggle.style.pointerEvents = "auto";
      localStorage.setItem("theme", document.documentElement.dataset.bsTheme);
      return clearInterval(interval);
    }

    let particleCount = 50 * (timeLeft / duration);

    // We let the confetti library handle the creation and deletion of the canvas element.
    confetti({ ...defaults, particleCount, origin: { x: Math.random() * (0.3 - 0.1) + 0.1, y: Math.random() - 0.2 } });
    confetti({ ...defaults, particleCount, origin: { x: Math.random() * (0.9 - 0.7) + 0.7, y: Math.random() - 0.2 } });

    document.documentElement.dataset.bsTheme = document.documentElement.dataset.bsTheme === "contrast" ? "light" : "contrast";
    contrastCheckbox.checked = document.documentElement.dataset.bsTheme === "contrast";

    logoImages.forEach((logoImage) => {
      const src = logoImage.src;
      logoImage.src = src.includes("light") ? src.replace("light", "contrast") : src.replace("contrast", "light");
    });
  }, 250);
});
